import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-find-policy-info-modal',
  templateUrl: './find-policy-info-modal.component.html',
})
export class FindPolicyInfoModalComponent implements OnInit {
  whereToFindModalOptions: ModalOptions;
  hideModal: boolean;
  isAcmic = false;

  constructor(private acmicService: AcmicService) {
    this.whereToFindModalOptions = new ModalOptions({
      additionalClasses: 'modal-small modal-dialog center-on-page signuptitle',
      additionalButtonClasses: 'dm-sans-medium fnd-pol',
      animatePosition: 'bottom',
      buttonCopy: 'WHERE_CAN_I_FIND_POLICY_INFO',
      modalId: 'helpModal',
      modalTranslateCopy: 'LOCATE_YOUR_POLICY_INFORMATION',
      typeOfModal: 'default',
      modalName: 'signup-process_Where_To_Find_Options',
    });
  }

  hideModalAction(): void {
    this.hideModal = !this.hideModal;
  }
  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    if(this.isAcmic) {
      this.whereToFindModalOptions.additionalButtonClasses = 'dm-sans-medium fnd-pol where-can-find-btn-acmic';
    }
  }
}
